/* eslint-disable */
// @ts-nocheck
import React, { useEffect, lazy, Suspense } from 'react';
import { useAppDispatch } from 'store/hooks';
import {
  setParamsSnapshot,
  setWidgetFlow,
  setAppChannel,
  checkAndSetIsSessionExpired,
  setInitialTheme,
} from 'store/slices/global';
import { getAppChannelFromUrl, getInitialTheme, getIsLLA } from 'utils';
import { FlowTypes } from 'store/constants';
import IntegrationCommunication from 'services/integration-communication';

import ModulorApp from 'Modulor/ModulorApp';
import ErrorBoundary from 'Modulor/components/ErrorPage/ErrorBoundary';

const DevView = process.env.NODE_ENV !== 'production' ? lazy(() => import('./DevView')) : () => null;

const initSentryAsync = () => {
  const sentryDSN = process.env.REACT_APP_SENTRY_DSN;
  if (sentryDSN) {
    import('./services/sentry').then((m) => m.initSentry(sentryDSN)).catch(() => {});
  }
};

initSentryAsync();

const { href: currentHref } = window.location;

const isWidgetPage =
  currentHref.includes('deposit') ||
  currentHref.includes('withdrawal') ||
  currentHref.includes('checkout') ||
  currentHref.includes('tokenization_page') ||
  currentHref.includes('acc_management') ||
  currentHref.includes('3ds_result') ||
  currentHref.includes('payments') ||
  currentHref.includes('cascading');

const App = () => {
  const dispatch = useAppDispatch();

  const { href, search } = window.location;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const cashierParam = params.get('cashier_in_new_tab');
    if (cashierParam === 'true' || cashierParam === '1') {
      const frameUrl = href.replace('cashier_in_new_tab=true', '');
      IntegrationCommunication.sendMessage({
        id: 'redirectTo',
        value: frameUrl,
      });
      return;
    }

    const flow =
      href.includes('withdrawal') && !href.includes('reject-withdrawal') ? FlowTypes.withdrawal : FlowTypes.deposit;
    const initialTheme = getInitialTheme();
    const appChannelFromUrl = getAppChannelFromUrl();

    dispatch(setParamsSnapshot(search));
    dispatch(setWidgetFlow(flow));
    dispatch(setAppChannel(appChannelFromUrl));
    dispatch(checkAndSetIsSessionExpired());
    dispatch(setInitialTheme(initialTheme));
  }, []);

  if (process.env.NODE_ENV !== 'production' && !isWidgetPage) {
    return (
      <Suspense fallback={null}>
        <DevView />
      </Suspense>
    );
  }

  return (
    <ErrorBoundary>
      <ModulorApp />
    </ErrorBoundary>
  );
};

export default App;
